import React from 'react';
import AnalyticsSerive from 'api/services/AnalyticsService';
import { tailwindConfig, hexToRGB, getI18nValue } from 'utils/Utils';
import LineChart03 from 'charts/LineChart03';
import LayoutWrapper from 'components/LayoutWrapper';
import { useTranslation } from 'react-i18next';
import { useAxios } from 'hooks/useAxios';
import PropTypes from 'prop-types';

function ConversationsChart({ dateRanges, channel, language }) {
    const { t } = useTranslation();
    const [data, error, loading] = useAxios(
        AnalyticsSerive.getConversationsKpi(dateRanges, channel, language)
    );

    return (
        <div className="col-span-full bg-white rounded-sm border border-gray-200 min-h-[360px] flex flex-col">
            <div className="px-4 pt-4 pb-2 border-b border-gray-100">
                <header className="capitalize text-lg font-semibold text-gray-800">
                    {t(getI18nValue('analytics.kpi.conversations', 'title'))}
                </header>
                <p className="text-sm font-light">
                    {t(getI18nValue('analytics.kpi.conversations', 'description'))}
                </p>
            </div>
            <LayoutWrapper error={error} loading={loading} variant="chart" isEmpty={!loading && !data} className="flex-1 min-h-0 p-2">
                <LineChart03
                    data={{
                        labels: data?.date || [],
                        datasets: [
                            {
                                label: '',
                                data: data?.total_conversation || [],
                                fill: true,
                                backgroundColor: `rgba(${hexToRGB(tailwindConfig().theme.colors.blue[500])}, 0.08)`,
                                borderColor: tailwindConfig().theme.colors.blue[500],
                                borderWidth: 2,
                                tension: 0.1,
                                pointRadius: 0,
                                pointHoverRadius: 3,
                                pointBackgroundColor: tailwindConfig().theme.colors.blue[500],
                                clip: 20,
                            },
                        ],
                    }}
                />
            </LayoutWrapper>
        </div>
    );
}

ConversationsChart.propTypes = {
  dateRanges: PropTypes.object.isRequired,
  channel: PropTypes.string,
  language: PropTypes.string,
};

export default ConversationsChart;
